export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_manage_all',
  'conversation_team_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  // WEBEXPERTO: permisos de interfaz sobre conversaciones no asignadas al operador (issue #63)
  'conversation_reply_without_assignment',
  'conversation_status_without_assignment',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  // WEXHUB: crear plantillas de WhatsApp y enviarlas a aprobacion de Meta
  'whatsapp_template_manage',
];

export const ROLES = ['agent', 'administrator'];

// WEXHUB: quienes pueden gestionar plantillas. Los administradores siempre.
export const WHATSAPP_TEMPLATE_PERMISSIONS = [
  'administrator',
  'whatsapp_template_manage',
];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_manage_all',
  'conversation_team_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const MANAGE_ALL_ACCOUNT_CONVERSATION_PERMISSIONS =
  'conversation_manage_all';

export const CONVERSATION_TEAM_PERMISSIONS = 'conversation_team_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

// WEBEXPERTO: permisos de interfaz sobre conversaciones no asignadas al operador (issue #63)
export const CONVERSATION_REPLY_WITHOUT_ASSIGNMENT_PERMISSION =
  'conversation_reply_without_assignment';

export const CONVERSATION_STATUS_WITHOUT_ASSIGNMENT_PERMISSION =
  'conversation_status_without_assignment';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      MANAGE_ALL_ACCOUNT_CONVERSATION_PERMISSIONS,
      CONVERSATION_TEAM_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      MANAGE_ALL_ACCOUNT_CONVERSATION_PERMISSIONS,
      CONVERSATION_TEAM_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
